import { render } from "./SankeyTab.vue?vue&type=template&id=877f5f10&scoped=true"
import script from "./SankeyTab.vue?vue&type=script&lang=js"
export * from "./SankeyTab.vue?vue&type=script&lang=js"

import "./SankeyTab.vue?vue&type=style&index=0&id=877f5f10&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-877f5f10"]])

export default __exports__